import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi, restaurantApi } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('gm_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await authApi.me();
      setUser(res.data);
      // Load restaurant
      const restRes = await restaurantApi.list();
      if (restRes.data && restRes.data.length > 0) {
        setRestaurant(restRes.data[0]);
      }
    } catch {
      localStorage.removeItem('gm_token');
      localStorage.removeItem('gm_user');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = (token, userData) => {
    localStorage.setItem('gm_token', token);
    localStorage.setItem('gm_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('gm_token');
    localStorage.removeItem('gm_user');
    setUser(null);
    setRestaurant(null);
    window.location.href = '/';
  };

  const refreshRestaurant = async () => {
    try {
      const res = await restaurantApi.list();
      if (res.data && res.data.length > 0) {
        setRestaurant(res.data[0]);
        return res.data[0];
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  return (
    <AuthContext.Provider value={{ user, restaurant, loading, login, logout, setRestaurant, refreshRestaurant }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
